// Every same-origin non-GET jQuery request (incl. DataTables) carries the XSRF token.
// A prefilter, not ajaxSetup({beforeSend}): a per-call beforeSend would replace the latter.
(function ($) {
    // A $(document).ready POST can beat the /a/xsrf fetch on a page that arrived with no
    // cookie; hold the send behind it rather than letting the request go out bare.
    function holdForToken(factory) {
        return function () {
            var xhr = factory.apply(this, arguments);
            var send = xhr.send;
            var abort = xhr.abort;
            var aborted = false;
            xhr.abort = function () { aborted = true; return abort.apply(xhr, arguments); };
            xhr.send = function (body) {
                window.JN.xsrf.ensure().then(function (token) {
                    if (aborted) return;
                    if (token) xhr.setRequestHeader('X-Xsrftoken', token);
                    send.call(xhr, body);
                });
            };
            return xhr;
        };
    }

    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (options.crossDomain) return;
        var type = String(options.type || 'GET').toUpperCase();
        if (type === 'GET' || type === 'HEAD' || type === 'OPTIONS') return;
        var token = window.JN.xsrf.token();
        if (token) jqXHR.setRequestHeader('X-Xsrftoken', token);
        else options.xhr = holdForToken(options.xhr || $.ajaxSettings.xhr);
    });
})(window.jQuery);
